export const textsDK = {
  // audit types
  UnpaidFee: 'Opslag',
  UnpaidPremium: 'Opslag restance',
  CompanyCreate: 'Virksomhed oprettet',
  CompanyEdit: 'Virksomhed rettet',
  CompanyDelete: 'Virksomhed slettet',
  UserCreate: 'Bruger oprettet',
  UserEdit: 'Bruger rettet',
  UserDelete: 'Bruger slettet',

  // opslag error codes and messages
  OPSLAG_001: 'Der er ikke angivet tilstrækkelig data for at kunne slå op i DFIM.',
  OPSLAG_002: 'Angivet nummer følger ikke standarden for CPR, CVR eller AKR nummer.',
  OPSLAG_003: 'CPR nummer må ikke indeholde bogstaver.',
  OPSLAG_004: 'Første 2 cifre må ikke være større end 31',
  OPSLAG_005: 'Ciffer 3-4 må ikke være større end 12',
  OPSLAG_006: 'Sidste 4 cifre i CPR nummeret er skrevet forkert.',
  OPSLAG_007: 'CPR nummeret består ikke af en gyldig dato',
  OPSLAG_008: 'CVR nummer må ikke indeholde bogstaver.',
};
